import { getEntitlementStatus } from '../api/client.ts';

const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

export async function pollForPaidEntitlement(
  childId,
  productId,
  { intervalMs = 2000, timeoutMs = 30000 } = {},
) {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const entitlement = await getEntitlementStatus(childId, productId);
    if (entitlement.status === 'paid') return entitlement;
    await delay(intervalMs);
  }
  throw new Error('timeout');
}
